import { ICONS } from "../../../assets/icons/index";

export const conversationSummaryList = [
  {
    id: 1,
    label: "New Conversations",
    key: "new_conversation",
    content:
      "Total number new conversation initiated by user within the selected date",
    color: "#5C3BBF",
    img: ICONS?.totalConversations,
  },
  {
    id: 2,
    label: "User Initiated",
    key: "user_initiated",
    color: "#32CDCD",
    content:
      "Total conversation initiated by user includes click to WhatsApp ads and facebook CTA",
    img: ICONS?.active,
  },
  {
    id: 3,
    label: "Business Initiated",
    key: "business_initiated",
    color: "#AC2F82",
    content: "Total number of conversations initiated by Business",
    img: ICONS?.unread,
  },
  {
    id: 4,
    label: "Resolved",
    key: "resolved",
    color: "#0ACD95",
    content: "Total number of conversation resolved within the selected date",
    img: ICONS?.resolved,
  },
];

export const connectWhatsapp = [
  {
    id: 1,
    title: "Connect WhatsApp Business API",
    subtitle: " Connect WhatsApp Business Platform (API)",
    description:
      "Connect your number with WhatsApp Business API and start engaging with customers efficiently.",
    content: "WhatsApp has been Connected Successfully",
    button: "Connect with Facebook",
    button1: "Connected",
    key: "connect_wapp_buss_api",
  },
  {
    id: 2,
    title: "Start Business Verification",
    content: "Business Verified Successfully",
    subtitle: "WhatsApp Business Verification",
    description:
      "Verify your business with Meta to build trust and gain access to advanced WhatsApp features.",
    button: "Start Business Verification",
    button1: "Business Verified Successfully",
    key: "start_buss_verification",
  },
  {
    id: 3,
    title: "Add Payment Method",
    content: "Payment Added Successfully",
    subtitle: "Payment Method",
    description:
      "Set up your preferred payment method to manage messaging costs smoothly.",
    button: "Manage Payment",
    button1: "Payment Added Successfully",
    key: "add_payment_method",
  },
  {
    id: 4,
    title: "Create Campaign",
    subtitle: "Send Broadcast",
    content: "Campaign Created Successfully",
    description:
      "Create and launch highly engaging WhatsApp campaigns. Leverage templates, automation, and audience targeting to maximize customer engagement.",
    button: "Create Campaign",
    button1: "Campaign Created Successfully",
    key: "is_campaign_created",
  },
  {
    id: 5,
    title: "Apply Blue Tick Verification",
    subtitle: "Blue Tick Verification",
    description:
      "Apply for verification and enhance customer trust with a recognized business profile.",
    button: "Contact Sales",
    button1: "Verfified Successfully",
    key: "green_tick_verified",
  },
];

// constants
export const aboutCardsList = [
  {
    id: 1,
    title: "Read our blog",
    image: ICONS?.homeBlogGainwix,
    content: `Learn more and and get inspired by our customers success stories.`,
    button: "Go to Gainwix's Blog",
    bgImage: "",
    url: "https://gainwix.com/blogs",
  },
  {
    id: 2,
    // title: "Help Center",
    image: ICONS?.homeHelp,
    content: "The AI Tsunami : Your Digital Agency's Survival Guide",
    button: "Read now",
    url: "https://gainwix.com/blogs/your_digital_agency's_survival_guide",
  },
  {
    id: 3,
    // title: "Gainwix Video Tour",
    image: ICONS?.homeVideoTour,
    content:
      "The Rise of Creator-Driven Commerce in India: From Reels to Riches",
    button: "Read now",
    url: "https://gainwix.com/blogs/The_Rise_of_Creator_Driven_Commerce_in_India",
  },
];
